import React, { useState } from "react";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import { Link } from 'react-router-dom';

const LoginPage: React.FC = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errorField, setErrorField] = useState<"username" | "password" | null>(null);
  

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage("");
        setErrorField(null);

        try {
            await login(username, password); // your existing login context
            navigate("/");
        } catch (error: any) {
            const msg = typeof error === "string"
                ? error
                : error?.message || "Login failed";

            if (error?.field) {
                setErrorField(error.field);
            }
            setMessage(msg);
        }     
    };

    return (
        <div className="login-page">
            <div className="login-form-wrapper">
                    <img src={`${process.env.PUBLIC_URL}/eda_login_logo.png`} alt="Logo" className="login-logo" />
    
                <div className="login-form-container">
                    <form onSubmit={handleSubmit} className="login-form">

                        <input
                            type="text"
                            placeholder="Username"
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className={errorField === "username" ? "input-error" : ""}
                        />
                    
                        {/* Password field with custom SVG eye icons */}
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className={errorField === "password" ? "input-error" : ""}
                            />
                            <span
                                className="password-eye"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <img
                                    src={
                                        showPassword
                                            ? `${process.env.PUBLIC_URL}/eye-openend.svg`
                                            : `${process.env.PUBLIC_URL}/eye-closed.svg`
                                    }
                                    alt={showPassword ? "Hide password" : "Show password"}
                                />
                            </span>
                        </div>

                        <div className="forgot-password">
                            <Link to="/forgot-password">Forgot password?</Link>
                        </div>
                        <button type="submit">Login</button>
                        {message && <p className="login-error">{message}</p>}
                    </form>
                    <div className="login-extra">
                        <p>
                            Don't have an account? <Link to="/signup">Sign up</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
